<template>
  <div class="content">
    <div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
import VueScrollTo from 'vue-scrollto'

export default {
  methods: {
    scrollTo (id) {
      try {
        let ele = document.getElementById(id)
        let options = {
          container: this.$el,
          easing: 'ease',
          x: false,
          y: true
        }
        VueScrollTo.scrollTo(ele, 300, options)
      } catch (err) {

      }
    },
    scrollToBottom () {
      this.$nextTick(() => {
        let dom = this.$el
        console.log(dom.scrollHeight)
        let options = {
          //          container: dom,
          easing: 'ease',
          offset: dom.scrollHeight,
          x: false,
          y: true
        }
        VueScrollTo.scrollTo(dom, 300, options)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  flex: 1;
  overflow: hidden;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  > div {
    //height: 100%;
  }
}
</style>
